import { FunctionComponent, useState } from 'react';
import {
    Card,
    CardContent,
    InputAdornment,
    SvgIcon,
    OutlinedInput,
} from '@mui/material';
import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';

type CustomersSearchProps = {
    onChange: (nextValue: string) => void;
};

export const CustomersSearch: FunctionComponent<CustomersSearchProps> = ({
    onChange,
}) => {
    const [textValue, setTextValue] = useState('');

    const handleTextChange = (event) => {
        const { value } = event.target;

        setTextValue(value);
        onChange(value);
    };

    return (
        <Card
            sx={{
                width: '100%',
            }}
        >
            <CardContent>
                <OutlinedInput
                    placeholder='Kunde suchen'
                    value={textValue}
                    onChange={handleTextChange}
                    startAdornment={
                        <InputAdornment position='start'>
                            <SvgIcon>
                                <MagnifyingGlassIcon />
                            </SvgIcon>
                        </InputAdornment>
                    }
                    fullWidth
                />
            </CardContent>
        </Card>
    );
};
